import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextField from '@mui/material/TextField';

import classes from './StepTwo.module.css';

const StepTwo = props => {
  const { t } = useTranslation(['lesson']);
  const [activityName, setActivityName] = useState();

  const handleChange = event => {
    setActivityName(event.target.value);
    props.activityTitleHandler(event.target.value);
  };

  return (
    <>
      <figure className={classes.stepNumber}>
        <img
          className={classes.numberImg}
          src="https://d1g6c01s9ssd7h.cloudfront.net/img/imageNumberActivity03.png"
          alt="number"
        />
      </figure>
      <p className={classes.titleActivity}>{t('assign_a_title')}</p>
      <TextField
        required
        className={classes.activityInput}
        onChange={handleChange}
        label={t('describe_your_task')}
        value={activityName}
      />
    </>
  );
};

StepTwo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  activityTitleHandler: PropTypes.func
};

export default StepTwo;
